import type { ButtonHTMLAttributes, JSX, ReactNode } from 'react'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  loading?: boolean
  children: ReactNode
}

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  className = '',
  children,
  ...props
}: ButtonProps): JSX.Element {
  const baseClass = 'fui-button'
  const variantClass = `fui-button-${variant}`
  const sizeClass = size !== 'md' ? `fui-button-${size}` : ''

  const classes = [baseClass, variantClass, sizeClass, className].filter(Boolean).join(' ')

  return (
    <button className={classes} disabled={disabled ?? loading} {...props}>
      {loading && <span className="fui-spinner fui-spinner-sm" />}
      {children}
    </button>
  )
}
